import React, { createContext, lazy, useReducer, useEffect } from "react";
import axios from "axios";
import LoadingPage from "./LoadingPage";
import { frontendEntorno } from "./config";
export const ThemeContext = createContext();

function getResolvedApiUrl() {
  const apiUrl = process.env.REACT_APP_FARMAGEO_API;

  if (!apiUrl) return "";

  try {
    const parsedUrl = new URL(apiUrl);
    const isLocalHost =
      parsedUrl.hostname === "localhost" || parsedUrl.hostname === "127.0.0.1";

    if (isLocalHost && typeof window !== "undefined") {
      parsedUrl.hostname = window.location.hostname;
    }

    return parsedUrl.toString().replace(/\/$/, "");
  } catch (error) {
    return apiUrl.replace(/\/$/, "");
  }
}

export const initialState = {
  logo: "",
  loading: true,
};

export const ThemeReducer = (state, action) => {
  switch (action.type) {
    case "SET_LOGO":
      return {
        ...state,
        logo: action.payload.logo,
        bgImage: action.payload.bgImage,
        logoWhite: action.payload.logoWhite,
        logoWhiteColegio: action.payload.logoWhiteColegio,
        logoWhiteColegioOld: action.payload.logoWhiteColegioOld,
      };
    case "SET_INIT_DATA":
      return {
        ...state,
        telefono: action.payload.telefono,
        direccion: action.payload.direccion,
        href_ubicacion: action.payload.href_ubicacion,
        texto_login: action.payload.texto_login,
        terminos_ida: action.payload.terminos_ida,
        recuperar_ida: action.payload.recuperar_ida,
        imagen_fondo: action.payload.imagen_fondo,
        imagen_logo: action.payload.imagen_logo,
        api_key_maps: action.payload.api_key_maps,
        loading: false,
      };
    default:
      return state;
  }
};

const theme = frontendEntorno.theme;
let ThemeComponent;

switch (theme) {
  case "amr":
    ThemeComponent = lazy(() => import("./themes/amrTheme/amrTheme"));
    break;
  case "orixia":
    ThemeComponent = lazy(() => import("./themes/orixiaTheme/orixiaTheme"));
    break;
  case "cfsf":
    ThemeComponent = lazy(() => import("./themes/cfsfTheme/cfsfTheme"));
    break;
  case "mfarmaceutica":
    ThemeComponent = lazy(() =>
      import("./themes/mfarmaceuticaTheme/mfarmaceuticaTheme")
    );
    break;
  default:
    ThemeComponent = lazy(() => import("./themes/default/defaultTheme"));
    break;
}

const ThemeG = (props) => {
  const [state, dispatch] = useReducer(ThemeReducer, initialState);
  const [error, setError] = React.useState(false);
  const apiBaseUrl = getResolvedApiUrl();

  useEffect(() => {
    const fetch_init_data = async () => {
      try {
        const res = await axios.post(`${apiBaseUrl}/init`);

        const init = res.data?.init;
        if (!init) throw new Error("Sin conexión");
        dispatch({
          type: "SET_INIT_DATA",
          payload: {
            telefono: init.telefono,
            direccion: init.direccion,
            href_ubicacion: init.href_ubicacion,
            texto_login: init.texto_login,
            terminos_ida: init.terminos_ida,
            recuperar_ida: init.recuperar_ida,
            imagen_fondo: init.imagen_fondo
              ? `${apiBaseUrl}/${init.imagen_fondo}`
              : state.bgImage,
            imagen_logo: init.imagen_logo
              ? `${apiBaseUrl}/${init.imagen_logo}`
              : state.logoWhiteColegio,
            loading: false,
            api_key_maps: init.api_key_maps
          },
        });
      } catch (err) {
        console.error("Error al obtener init:", err);
        setError(true);
      }
    };

    fetch_init_data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loading = () => <LoadingPage />;

  return (
    <ThemeContext.Provider value={{ ...state, theme, dispatch }}>
      <React.Suspense fallback={loading()}>
        {error ? (
          <LoadingPage texto="Error de conexión." />
        ) : (
          <ThemeComponent>{props.children}</ThemeComponent>
        )}
      </React.Suspense>
    </ThemeContext.Provider>
  );
};

export default ThemeG;

function testComponent({ children }) {
  return (
    <>
      <h2>Hola Test</h2>
      <div>{children}</div>
    </>
  );
}
